import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n
  .use(Backend) // Enables the i18next backend
  .use(LanguageDetector) // Enable automatic language detection
  .use(initReactI18next) // Enables the hook initialization module
  .init({
    lng: 'sk',
    fallbackLng: 'en',
    preload: [ "en","sk", "cs"],
    backend: {
      /* translation JSON path */
      loadPath: `${process.env.REACT_APP_SERVER_HOST}/locales/get/{{lng}}`
    },
    debug: false,
    keySeparator: false,
    react: {
      useSuspense: false
    },
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    }
  })

export default i18n
